module.exports = __webpack_public_path__ + "static/media/new-01.68d72b7.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-01.mp4
// module id = fl6T
// module chunks = 0